import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/nf/di-controle/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findDiControle({
  empresa_cnpj,
  id,
  include = "",
  page,
  where = {},
  orwhere = {},
  isSameOrWhere = false,
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere${isSameOrWhere ? "[]" : ""}[${key}]=${
      orwhere[key]
    }`;
  });

  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }${page ? `&page=${page}` : ""}`,
    "GET",
    headers
  );
}

export async function createDiControle(empresa_cnpj, body) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export async function updateDiControle(id, empresa_cnpj, body) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}

export function deleteDiControle(id, empresa_cnpj) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "DELETE",
    headers
  );
}
